var _desc, _defs, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithWritingWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430 128",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "luvioo logo white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "White luvioo wordmark with heart icon for dark backgrounds.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "whiteShadow",
    x: "-10%",
    y: "-20%",
    width: "120%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 10,
    floodColor: "#f8d9ea",
    floodOpacity: 0.18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#whiteShadow)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M64 108.5c-3.7-3.2-7.6-6.3-11.8-9.2C30.6 84.5 16 70.5 16 49.3 16 31.5 29.8 18 47.1 18c7.9 0 13.7 2.4 16.9 7.4 3.2-5 9-7.4 16.9-7.4C98.2 18 112 31.5 112 49.3c0 21.2-14.6 35.2-36.2 50-4.2 2.9-8.1 6-11.8 9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbeff6",
    fillOpacity: 0.58,
    d: "M80.8 28.5c10.6 0 19.2 8.2 19.2 19 0 3.8-0.9 7.3-2.7 10.5 0.1-1 0.2-2 0.2-3 0-10.8-8.6-19-19.2-19-5.6 0-10 1.4-14.3 5.1 2.2-8.1 8.7-12.6 16.8-12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 0.9,
    d: "M97.5 40.5c-0.9-7 4.6-12.8 11.4-13.3-6.8-0.6-12.2-6.5-11.4-13.4 0.8 6.9-4.7 12.8-11.4 13.4 6.7 0.5 12.2 6.3 11.4 13.3Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 138,
    y: 82,
    fill: "#ffffff",
    fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
    fontSize: 72,
    fontWeight: 800,
    letterSpacing: -3
  }, "\n    luvioo\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithWritingWhite);
export default __webpack_public_path__ + "static/media/logo-with-writing-white.ec01c194a6fdfb3446c67417af7da670.svg";
export { ForwardRef as ReactComponent };